export default __webpack_public_path__ + "b3bfd70e1e191b07e9ff236ea83c8c10.png";